<div class="fees-allowances-container">
  <div class="header-actions">
    <button mat-stroked-button color="primary" (click)="openNewAllowanceDialog()">
      <mat-icon>add</mat-icon>
      NEW ALLOWANCE
    </button>
    <button mat-stroked-button color="accent" (click)="openNewFeeDialog()">
      <mat-icon>add</mat-icon>
      NEW FEE
    </button>
  </div>

  <div class="fees-list">
    <!-- Fees/allowances defined in the system (admin catalog) -->
    @for (def of catalogFees; track def.id) {
      <div class="fee-item">
        <div class="fee-info">
          <mat-slide-toggle
            [checked]="isApplied(def)"
            (change)="toggleCatalogItem(def, $event.checked, $event.source)">
            {{ def.name }}
          </mat-slide-toggle>
        </div>
        @if (appliedFor(def); as a) {
          <div class="fee-amount" [class.allowance]="def.type === 'Allowance'">
            {{ def.type === 'Allowance' ? '-' : '' }}{{ a.amount | currency }}
          </div>
        }
      </div>
    }

    <!-- Custom Fees -->
    <div class="fee-item custom-item" *ngFor="let fee of customFees">
      <div class="fee-info">
        <span class="custom-label">{{ fee.name }}</span>
      </div>
      <div class="fee-actions">
        <span class="fee-amount">{{ fee.amount | currency }}</span>
        <button mat-icon-button (click)="deleteCustomFee(fee.id!)" class="delete-button">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>

    <!-- Custom Allowances -->
    <div class="fee-item custom-item" *ngFor="let allowance of customAllowances">
      <div class="fee-info">
        <span class="custom-label">{{ allowance.name }}</span>
      </div>
      <div class="fee-actions">
        <span class="fee-amount allowance">-{{ allowance.amount | currency }}</span>
        <button mat-icon-button (click)="deleteCustomAllowance(allowance.id!)" class="delete-button">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
